import React from "react";
import PropTypes from "prop-types";
import { useMedia } from "use-media";

import { InnerContainer } from "../../layouts/Default";

import BotaoCTA from "../BotaoCTA";
import TwoCardsMobile from "./TwoCardsMobile";
import MultipleCards from "./MultipleCards";
import Card from "../Card";
import { Botao, ContainerListButton, Imagem } from "./styles";

export default function ListaCardsPassoAPasso(props) {
  const isMobile = useMedia({
    maxWidth: 991
  });

  const isZoom = useMedia({
    maxWidth: 1280
  });

  const { botao, id, botaoEmbaixo, listaDeCards } = props;
  const imagem = props.stepsFirstArrow;
  const imagemAux = props.stepsSecondArrow;
  const tamanhoListaCards = props.listaDeCards.length;
  const responsive = [
    { breakPoint: 1100, cardsToShow: 3 },
    { breakPoint: 768, cardsToShow: 2 },
    { breakPoint: 0, cardsToShow: 1 }
  ];

  if (tamanhoListaCards === 2 && isMobile) {
    return (
      <TwoCardsMobile
        id={id}
        imagem={imagem}
        imagemAux={imagemAux}
        tamanhoListaCards={tamanhoListaCards}
        botao={botao}
        listaDeCards={listaDeCards}
        responsive={responsive}
      />
    );
  }

  if (tamanhoListaCards > 2) {
    return (
      <MultipleCards
        id={id}
        imagem={imagem}
        imagemAux={imagemAux}
        tamanhoListaCards={tamanhoListaCards}
        botao={botao}
        listaDeCards={listaDeCards}
        responsive={responsive}
        botaoEmbaixo={botaoEmbaixo}
        isZoom={isZoom}
      />
    );
  }

  return (
    <InnerContainer>
      <ContainerListButton>
        <div className={`card-list-item${id}`}>
          {" "}
          <Card
            card={props.listaDeCards[0]}
            key={props.listaDeCards[0].name}
            transparent
          />
        </div>
        {imagem && <Imagem src={imagem} />}
        <div className={`card-list-item${id}`}>
          <Card
            card={props.listaDeCards[1]}
            key={props.listaDeCards[1].name}
            transparent
          />
        </div>
        {botao && (
          <Botao>
            <BotaoCTA botao={botao} />
          </Botao>
        )}
      </ContainerListButton>
    </InnerContainer>
  );
}

ListaCardsPassoAPasso.propTypes = {
  imagem: PropTypes.object,
  imagemAux: PropTypes.object,
  listaDeCards: PropTypes.array
};
